import { render, staticRenderFns } from "./GrayRelease.vue?vue&type=template&id=401504f3&scoped=true"
import script from "./GrayRelease.vue?vue&type=script&lang=js"
export * from "./GrayRelease.vue?vue&type=script&lang=js"
import style0 from "./GrayRelease.vue?vue&type=style&index=0&id=401504f3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401504f3",
  null
  
)

export default component.exports